module.exports = __webpack_public_path__ + "static/iclcrest-a829ec5ed8ae36d76f4cef34a8aa1392.png";